import { InjectionToken } from '@angular/core';

export const ICON_SERVICE_ICON_LOCATION = new InjectionToken<string>('IconServiceIconLocation');
